/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssegnazioneArticoloCedolaListFilter { 
    area?: string;
    editore?: string;
    attivo?: boolean;
    q?: string;
    istituto_id?: string;
    plesso_id?: string;
    assegnazione_id?: string;
    classe?: string;
    sezione?: string;
}

